module.exports = __webpack_public_path__ + "static/work-life-balance-icon-20df6682cdfb04dbabb187bb07a2f2b5.svg";